import React from "react";
import Modal from "react-bootstrap/Modal";

const SwModal = ({
  show,
  onClose,
  title,
  children,
  footer,
  size = "md",
  centered = true,
  backdrop = "static",
  keyboard = false,
  className = "", //sw-small-modal, sw-default-modal, sw-large-modal
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size={size}
      centered={centered}
      backdrop={backdrop}
      keyboard={keyboard}
      className={`sw-modal ${className}`}
    >
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body>{children}</Modal.Body>

      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default SwModal;
